(() => {
  if (customElements.get('skr-account-menu')) return;
  class AccountMenu extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.trigger = this.querySelector('.skr-account-menu__trigger');
      this.panel = this.querySelector('.skr-account-menu__panel');
      this.abort = new AbortController();
      const on = (node, type, handler) => node.addEventListener(type, handler, { signal: this.abort.signal });
      this.hover = matchMedia('(hover: hover) and (pointer: fine)');
      this.opened = false;
      this.pinned = false;
      on(this.trigger, 'click', () => {
        if (this.opened && this.pinned) this.close(true);
        else { this.pinned = true; this.open(); }
      });
      on(this.trigger, 'keydown', e => {
        if (e.key === 'ArrowDown') {
          e.preventDefault(); this.pinned = true; this.open();
          this.panel.querySelector('a')?.focus();
        }
      });
      const enter = e => {
        if (e.pointerType !== 'mouse' || !this.hover.matches) return;
        clearTimeout(this.timer); this.open();
      };
      const leave = e => {
        if (e.pointerType !== 'mouse' || !this.hover.matches || this.pinned) return;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          if (!this.contains(document.activeElement)) this.close();
        }, 250);
      };
      on(this, 'pointerenter', enter); on(this, 'pointerleave', leave);
      on(this.panel, 'pointerenter', () => clearTimeout(this.timer));
      on(this.panel, 'pointerleave', leave);
      on(this.panel.querySelector('.skr-account-menu__close'), 'click', () => this.close(true));
      on(document, 'pointerdown', e => { if (this.opened && !this.contains(e.target)) this.close(); });
      on(document, 'keydown', e => {
        if (this.opened && e.key === 'Escape') { e.preventDefault(); this.close(true); }
      });
      on(this, 'focusout', e => {
        if (this.opened && !this.contains(e.relatedTarget)) this.close();
      });
      on(this.panel, 'click', e => {
        const link = e.target.closest('a');
        if (!link) return;
        if (link.hasAttribute('data-skr-account-wishlist')) {
          const hero = document.querySelector('.header__icon--wishlist');
          if (hero) { e.preventDefault(); this.close(); hero.click(); return; }
        }
        this.close();
      });
      on(window, 'resize', () => this.position());
      // Close on page scroll so a sticky header cannot leave a detached panel.
      on(window, 'scroll', () => { if (this.opened) this.close(); });
      on(window, 'pagehide', () => this.close());
      on(window, 'pageshow', e => { if (e.persisted) location.reload(); });
    }
    open() {
      clearTimeout(this.timer);
      if (this.opened) return;
      document.querySelectorAll('skr-account-menu').forEach(el => { if (el !== this) el.close?.(); });
      this.opened = true;
      this.panel.hidden = false;
      if (this.panel.showPopover) this.panel.showPopover();
      this.trigger.setAttribute('aria-expanded', 'true');
      this.position();
    }
    position() {
      if (!this.opened) return;
      const rect = this.trigger.getBoundingClientRect();
      const view = window.visualViewport;
      const width = view?.width || document.documentElement.clientWidth;
      const height = view?.height || window.innerHeight;
      const top = Math.max(12, Math.min(rect.bottom + 10, height - 160));
      this.panel.style.top = `${top}px`;
      this.panel.style.left = `${Math.max(12, Math.min(rect.right - this.panel.offsetWidth, width - this.panel.offsetWidth - 12))}px`;
      this.panel.style.maxHeight = `${Math.max(120, height - top - 12)}px`;
    }
    close(restore = false) {
      clearTimeout(this.timer);
      if (!this.opened) return;
      this.opened = false; this.pinned = false;
      if (this.panel.hidePopover && this.panel.matches(':popover-open')) this.panel.hidePopover();
      this.panel.hidden = true;
      this.trigger.setAttribute('aria-expanded', 'false');
      if (restore) this.trigger.focus();
    }
    disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); this.ready = false; }
  }
  customElements.define('skr-account-menu', AccountMenu);
})();
